module.exports = __webpack_public_path__ + "static/img/Main beam 2,4m (Hollow 50x50 x2,4m).9f1be6b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/Main beam 2,4m (Hollow 50x50 x2,4m).jpg
// module id = 86
// module chunks = 1